import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Product Brands API functions
export const createProductBrand = async (brandData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.PRODUCT_BRANDS.CREATE, {
      name: brandData.name, // required
      slug: brandData.slug, // optional
      description: brandData.description, // optional
      image: brandData.image, // optional, number (media ID)
      isPopular: brandData?.isPopular || false, // optional, boolean
      seoContent: brandData?.seoContent || "",
      seoTitle: brandData?.seoTitle || "",
      keyword: brandData?.keyword || "",
    });
    return response.data;
  } catch (error) {
    console.error('Error creating product brand:', error);
    throw error;
  }
};

export const updateProductBrand = async (brandId, updateData) => {
  try {
    const response = await axiosInstance.put(`${API_ROUTES.PRODUCT_BRANDS.UPDATE}/${brandId}`, {
      name: updateData.name, // optional
      slug: updateData.slug, // optional
      description: updateData.description, // optional
      image: updateData.image, // optional, number (media ID)
      isPopular: updateData?.isPopular || false, // optional, boolean
      seoContent: updateData?.seoContent || "",
      seoTitle: updateData?.seoTitle || "",
      keyword: updateData?.keyword || "",
    });
    return response.data;
  } catch (error) {
    console.error('Error updating product brand:', error);
    throw error;
  }
};

export const getProductBrands = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams.page || 1,
      perPage: queryParams.perPage || 20,
      search: queryParams.search || '',
      orderBy: queryParams.orderBy || 'date' // 'name' or 'date'
    };
    const response = await axiosInstance.get(API_ROUTES.PRODUCT_BRANDS.GET, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching product brands:', error);
    throw error;
  }
};

export const deleteProductBrands = async (brandIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.PRODUCT_BRANDS.DELETE, {
      data: {
        ids: brandIds // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting product brands:', error);
    throw error;
  }
};

export const getAllProductBrands = async (queryParams = {}) => {
  try {
    const params = {
      isPopular: queryParams?.isPopular || false,
      isLatest: queryParams?.isLatest || false,
      brandCount: queryParams?.brandCount || 5,
    };
    const response = await axiosInstance.get(`${API_ROUTES.PRODUCT_BRANDS.GET_ALL}`, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

// Additional functions can be added here as needed